module.exports = __webpack_public_path__ + "static/media/Leo.5a405701.png";